export default function buildName(fieldName, opId, _path) {
  return `${opId}-${fieldName}-${_path}`;
}
